//@ts-nocheck
import React, { forwardRef, useEffect } from 'react';
import DatePickerWrapper from '../DatePickerWrapper';
import WeekDays from '../weekDays/WeekDays';
import DayDatePicker from '../dayDatePickerWrapper/datepickerDays/DatepickerDays';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import useDatepicker from '../hooks/useDatepicker';
import styles from './WeekDatepicker.module.scss';
import { persianMonthNameConvertor } from '@/helpers/dateManager';
const DatePicker = forwardRef(({
  checkInDate,
  checkOutDate,
  hoveredDate,
  onDayClick,
  onDayHover,
  todayDate,
  nextRangeDays,
  days,
  footerChildren,
  isFull,
  index,
  withTooltip
}, ref) => {
  const {
    dayRefs,
    hoverRef,
    leaveRef,
    isDayDisabled,
    getClassNames,
    handleDayClick,
    getDatePickerTooltipData,
    getStateAndClassNames,
    formatPrice
  } = useDatepicker({
    checkInDate,
    checkOutDate,
    hoveredDate,
    onDayClick,
    onDayHover,
    todayDate,
    nextRangeDays,
    pickerDate: {
      days
    },
    index,
    onlyDays: true
  });
  const selectedMonths = days.length ? `${persianMonthNameConvertor(days[0])} ${days[20].month !== days[0].month ? ' - ' + persianMonthNameConvertor(days[20]) : ''}` : '';
  return <Box className={` ${styles['week-datepicker']}`}>
        <Box className={`${styles['calendar-wrapper']} ${styles['week-datepicker']}`}>
          <Box className={styles['calendar-week-header']}>
            <Typography className={styles['calendar-week-title']} variant="bodyL_Bold">
              انتخاب تاریخ
            </Typography>
            <Typography variant="bodyL_Bold">{selectedMonths}</Typography>
          </Box>
          <WeekDays fullWidth />
          <Box className={styles['single-day-container']}>
            {days.map((item, index) => <DayDatePicker key={item.ts} ref={el => dayRefs.current[item.ts] = el} item={item} checkInDate={checkInDate} checkOutDate={checkOutDate} hoveredDate={hoveredDate} todayDate={todayDate} nextRangeDays={nextRangeDays} isFull={isFull} classNameList={getStateAndClassNames(item).classNames} tooltipContent={getDatePickerTooltipData(item, index)} formatPrice={formatPrice} withTooltip={withTooltip} onDayClick={handleDayClick} />)}
          </Box>
          {footerChildren && <>{footerChildren}</>}
        </Box>
      </Box>;
});
DatePicker.displayName = 'DatePicker';
const DatePickerWeek = props => {
  return <DatePickerWrapper WrappedDatePicker={DatePicker} datePickerType="DAYS_RANGE" ref={props.dateRef} {...props} data-sentry-element="DatePickerWrapper" data-sentry-component="DatePickerWeek" data-sentry-source-file="WeekDatepicker.tsx" />;
};
export default DatePickerWeek;